import { LogFilterType } from "../HelperSrc";
import { lang } from "../lang";

const logFilterTypes = (): LogFilterType[] => [
    {
        key: "All",
        name: lang.all,
        "data-at_id": "logs_all"
    },
    {
        key: "Login",
        name: lang.login,
        "data-at_id": "logs_login"
    },
    {
        key: "Table",
        name: lang.table,
        "data-at_id": "logs_table"
    },
    {
        key: "File",
        name: lang.file,
        "data-at_id": "logs_file"
    }
];

export { logFilterTypes };
